bovoApp.controller('HolidayController', ['$scope', 'Holiday', '$location', '$routeParams', '$filter', '$translate',
  function ($scope, Holiday, $location, $routeParams, $filter, $translate) {
    $scope.deleted = [];


    $scope.all = function () {
      Holiday.all($scope.type).success(function (data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.openDetail = function (item) {
      Holiday.get(item.id).success(function (data, status, headers, config) {
        $('#holidayModal').modal('show');
        $scope.holiday = data.holiday;
      });
    }

    $scope.$on('new_data', function () {
      $('#holidayModal').modal('show');
      $scope.new();
    }, true);

    $scope.new = function () {
      Holiday.new().success(function (data, status, headers, config) {
        $scope.data.vehicleRoutes = data.vehicleRoutes;
        $scope.holiday = {
          type: $scope.type,
          performance: 'no'
        };
      });
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        Holiday.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post($scope.translate(data.message.toString()));
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.holidays.indexOf($filter('filter')($scope.data.holidays, {
              id: $scope.deleted[i]
            })[0]);
            if (index > -1) {
              $scope.data.holidays.splice(index, 1);
            }
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.postForm = function (user) {
      if ($scope.holiday.id) {
        $scope.update();
      } else {
        $scope.save();
      }
    }

    $scope.save = function () {
      Holiday.save($scope.holiday).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#holidayModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.update = function () {
      Holiday.update($scope.holiday).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#holidayModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

  }
]);